import React, { useEffect, useState } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { TableFirstRow } from "../fui/FuiStyles";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button, DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core/";
import { CommonDialog } from "../common/CommonComponents/Dialog";
import { PrimaryButton } from "../common/CommonComponents/Buttons";

export default function Requests(props) {
  const useStyles = makeStyles((theme) => ({
    requestOpenAIButton: {
      backgroundColor: "rgb(21, 101, 192)",
      color: "white",
      float: "right"
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [requestData, setRequestData] = useState("");
  const l3Url =
    "https://mywizard-aiops.accenture.com/resources/support-requests/";

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewDetails = (data) => {
    setRequestData(data)
    setOpen(true);
  }


  return (
    <div style={{ marginBottom: "5%" }}>
      {props.data.length === 0 ?
        <p style={{ fontSize: "1.15rem", color: "black !important" }}><b>No requests found!</b></p> :
        <div>
          <Paper>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>REQUEST ID</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>ASSET NAME</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>MANAGER NAME</b></TableFirstRow>
                  {/* <TableFirstRow style={{ color: "#53575b" }}><b>INSTANCE OWNER</b></TableFirstRow> */}
                  <TableFirstRow style={{ color: "#53575b" }}><b>PURPOSE</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>CREATED DATE</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>APPROVAL STATUS</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b>REQUEST STATUS</b></TableFirstRow>
                  <TableFirstRow style={{ color: "#53575b" }}><b></b></TableFirstRow>
                </TableRow>
              </TableHead>
              {props.data.length > 0 ?
                (props.data.map((row, key) => (
                  row.approvalStatus == '-' || row.RequestStatus === "Validating" ? "" :
                    <TableBody>
                      <TableRow key={key}>
                        <TableCell> {row.RequestId} </TableCell>
                        <TableCell> {row.AssetName} </TableCell>
                        <TableCell> {row.ManagerName} </TableCell>
                        {/* <TableCell> {row.InstanceOwner} </TableCell> */}
                        <TableCell> {row.Purpose} </TableCell>
                        <TableCell> {row.OrderDate} </TableCell>
                        <TableCell> {row.ApprovalStatus} </TableCell>
                        <TableCell> {row.RequestStatus}</TableCell>
                        <TableCell>
                          <div>
                            <Button size="small" onClick={() => handleViewDetails(row)}><span style={{ color: "#1565c0" }}>View Details</span></Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                ))) : ""}
            </Table>
          </Paper>
          <CommonDialog
            className="AzureOpenAIDialog"
            open={open}
            onClose={handleClose}
            title={"Open AI Access Status"}
            dialogType={"fui"}
            dialogContent={
              <DialogContent>
                <DialogContentText id="alert-dialog-descreption">
                  <div>
                    {
                      (() => {
                        if (requestData.Status == "Pending" || requestData.Status == "In-Progress" || requestData.RequestStatus == "Pending" || requestData.RequestStatus == "In-Progress")
                          return (
                            <Typography sx={{ mt: 2, mb: 1 }} >
                              <p style={{ fontSize: "1.1rem", color: "#1565c0 !important" }}><b>Thank you for your interest in OpenAI!</b></p>
                              <p><b>We have received your access request and it is currently being processed.</b></p>
                              <p>Once your request has been reviewed, you will receive a notification via email. The email will provide you with all the necessary information and instructions to proceed. </p><p>We appreciate your interest in OpenAI and will keep you updated on the status of your request.</p>
                            </Typography>
                          )
                        else if (requestData.Status == "Declined" || requestData.Status == "Failed" || requestData.RequestStatus == "Declined" || requestData.RequestStatus == "Failed")
                          return (
                            <Typography sx={{ mt: 2, mb: 1 }}>
                              <p style={{ fontSize: "1.1rem", color: "#1565c0 !important" }}><b>We regret to inform you that your OpenAI access request has been declined.</b></p>
                              <p>Please check your email for more details regarding the decision. The email will provide additional information explaining the reason for the decline and any further steps, if applicable. </p><p>Thank you!</p>
                            </Typography>
                          )
                        else if (requestData.Status == "Completed" || requestData.Status == "Approved" || requestData.RequestStatus == "Completed" || requestData.RequestStatus == "Approved")
                          return (
                            <Typography sx={{ mt: 2, mb: 1 }}>
                              <p style={{ fontSize: "1.15rem", color: "black !important" }}><b>Congratulations! Your OpenAI access request has been processed successfully.</b></p>
                              <p style={{ marginTop: "5%" }}>Please check <b>Active OpenAI's</b> section for further details and any additional information related to your request.</p>
                              <p>If your access details are not present in that section. Please reach out to support team by raising a {" "}
                                <a href={l3Url} target="_blank" rel="noopener noreferrer">
                                  support ticket
                                </a> to further investigate on this.</p>
                            </Typography>
                          )
                        else return ("")
                      })()
                    }
                  </div>
                </DialogContentText>
              </DialogContent>
            }
            dialogActions={
              <DialogActions>
                <PrimaryButton
                  data-cy="dialogOkButton"
                  variant="outlined"
                  onClick={handleClose}
                  label={"Close"}
                  className={classes.requestOpenAIButton}
                />
              </DialogActions>
            }
          >
          </CommonDialog>
        </div>}
    </div>
  );
}

